import ConversationEffect from "src/Animations/ConversationEffect";
import setCurrentPage from "src/Utils/setCurrentPage";
import setPreviousPage from "src/Utils/setPreviousPage";

export const DATA_DOW_DEMO_DNA1_5 = {
  title: `She initiated the <span style="color: #92D1FF;">Diagnostics module</span> to\n examine the utilization of data, aiming to \ngain insights into both data and tool \nusage. The gathered data helps optimize \nthe landscape and reduce the overall \nspending on the cloud.`,
  subtitle: "Data Operations Workbench demo",
  label: [{ iconPath: "start.png", text: "Diagnostics" }],
  next: {
    label: "CONTINUE",
    onClick: () => {
      setPreviousPage(109);
      setCurrentPage(110);
    },
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(108),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "DNA1/DNA1_intro_04.jpg",
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "InfosysTopazLogo.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "DNA1/DNA1_DOW_DEMO_05_Computer.png",
          imageStyle: {
            position: "absolute",
            right: "193.67px",
            bottom: "225.84px",
          },
          effect: "animate-opacity",
        },
        {
          image: "DNA1/DNA1_DOW_DEMO_05_PopUp_1.png",
          imageStyle: { position: "absolute", right: "295px", bottom: "495px" },
        },
        {
          image: "DNA1/DNA1_DOW_DEMO_05_PopUp_2.png",
          imageStyle: { position: "absolute", right: "130px", bottom: "155px" },
        },
      ]}
      pageNumber={109}
    />
  ),
};
